<div
  [class]="{
    clickable: isBlazeTable,
    selected: isSelected,
    preview: previewOnly,
    'more-open': moreOpen(),
  }"
  (click)="editIfBlazeTable()"
  class="dataset-toggle menu-item-with-action-icons"
>
  @if (!!dataset() && !isLink && !isChangeTracking) {
    <mat-icon svgIcon="icon_dataset_32" class="mr-10 icon dataset" />
  }
  @if (!!dataset() && !isLink && isChangeTracking) {
    <mat-icon svgIcon="icon_tracking_16" class="mr-10 icon dataset" />
  }
  @if (!!dataset() && isLink) {
    <mat-icon svgIcon="icon_blaze_table_linked_32" class="mr-10 icon dataset" />
  }
  @if (!!actionName) {
    <mat-icon svgIcon="icon_function_32" class="mr-10 icon" />
  }
  <div class="label text-primary-darker">
    <span class="truncate" [blazeTooltip]="name()">{{ name() }}</span>
  </div>
  @if (actions === 'share' && isShared() && !moreOpen()) {
    <mat-icon class="icon icon-shared" svgIcon="globe" />
  }
  @if (!actionName) {
    <mat-icon
      (click)="showPreview.emit()"
      class="icon p-4 rounded icon-preview"
      data-cy="DatasetToggle:preview"
      svgIcon="icon_preview_16"
    />
  }
  @switch (actions) {
    @case ('delete') {
      @if (
        isBlazeTable &&
        !isLink &&
        !isSystemTable &&
        ((isRootUser && isChangeTracking) || !isChangeTracking)
      ) {
        <mat-icon
          svgIcon="icon_trash_16"
          data-cy="DatasetToggle:delete"
          (click)="deleteDataset.emit(); $event.stopPropagation()"
          class="icon ml-8 p-4 rounded icon-delete"
        />
      }
    }
    @case ('share') {
      <blaze-optional-actions
        (menuOpen)="moreOpen.set($event)"
        [actions]="actionsList()"
        [maxCount]="1"
        class="icon icon-actions ml-8"
        iconSize="30px"
      />
    }
  }
  @if (!previewOnly && !isBlazeTable) {
    <div class="ml-8 toggle">
      <mat-slide-toggle
        (change)="notifyToggleChanged()"
        [(ngModel)]="isSelected"
        class="bd-toggle"
        disableRipple
      />
    </div>
  }

  @if (showMenuOptions && !isBlazeTable) {
    <mat-icon
      [matMenuTriggerFor]="menu"
      class="mr-8 action-icon options-icon"
      svgIcon="icon_more_h_24"
    />
  }

  <!-- More options menu -->
  <mat-menu class="options-menu" #menu="matMenu">
    <button mat-menu-item (click)="editDataset.emit()">
      <mat-icon class="menu-icon" svgIcon="icon_edit_24" />
      <span>Edit Table</span>
    </button>
    @if (!isSystemTable && !isChangeTracking) {
      <button mat-menu-item (click)="deleteDataset.emit()" color="!text-warn">
        <mat-icon class="menu-icon" svgIcon="icon_trash_16" />
        <span class="menu-label !text-warn">Delete Table</span>
      </button>
    }
  </mat-menu>
</div>
